//引入vue
import Vue from 'vue'
//引入vue-router
import VueRouter from 'vue-router'
import Home from './components/Home'
import Login from './module/login/Login'
import { getRouter } from './config/RouterConfig'
//第三方库需要use一下才能用
Vue.use(VueRouter);
//过滤重复点击问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
//定义routes路由的集合，数组类型
const routes = [
  {
    path: '/',
    name: 'index',
    component: Login
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    children: getRouter()
  },
  {
    path: '*', redirect: '/404', hidden: true
  },
  {
    path: '/404',
    component: () => import( './module/exception/404')
  }
];

//实例化VueRouter并将routes添加进去
const router = new VueRouter({
  mode: 'history',
//ES6简写，等于routes：routes
  routes
});

//抛出这个这个实例对象方便外部读取以及访问
export default router
